var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-register)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87177 10.7718C3.62191 10.0217 4.63933 9.60024 5.7002 9.60024L11.3002 9.60024C12.3611 9.60024 13.3785 10.0217 14.1286 10.7718C14.8788 11.522 15.3002 12.5394 15.3002 13.6002V15.2002C15.3002 15.6421 14.942 16.0002 14.5002 16.0002C14.0584 16.0002 13.7002 15.6421 13.7002 15.2002V13.6002C13.7002 12.9637 13.4473 12.3533 12.9973 11.9032C12.5472 11.4531 11.9367 11.2002 11.3002 11.2002L5.7002 11.2002C5.06368 11.2002 4.45323 11.4531 4.00314 11.9032C3.55305 12.3533 3.3002 12.9637 3.3002 13.6002L3.3002 15.2002C3.3002 15.6421 2.94202 16.0002 2.5002 16.0002C2.05837 16.0002 1.7002 15.6421 1.7002 15.2002L1.7002 13.6002C1.7002 12.5394 2.12162 11.522 2.87177 10.7718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5002 1.60024C7.17471 1.60024 6.1002 2.67476 6.1002 4.00024C6.1002 5.32573 7.17471 6.40024 8.5002 6.40024C9.82568 6.40024 10.9002 5.32573 10.9002 4.00024C10.9002 2.67476 9.82568 1.60024 8.5002 1.60024ZM4.5002 4.00024C4.5002 1.79111 6.29106 0.000244141 8.5002 0.000244141C10.7093 0.000244141 12.5002 1.79111 12.5002 4.00024C12.5002 6.20938 10.7093 8.00024 8.5002 8.00024C6.29106 8.00024 4.5002 6.20938 4.5002 4.00024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-register"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.29179cb0.svg";
export { ForwardRef as ReactComponent };